import React, { useEffect, useState, useCallback } from 'react'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { useOOLocations } from 'public/components/online_ordering/FulfillmentContext'
import {
  Modal,
  ModalContent,
  ModalOverlay
} from 'shared/components/common/modal/Modal'
import NoItems from './NoItemsIcon'
import { t } from 'src/translations'

import { ButtonType } from 'src/apollo/sites'
import { BrandedButton } from 'src/shared/components/common/button'

type ErrorNavigationModalProps = {
  isOpen: boolean
  onClose: () => void
}

export const ErrorNavigationModal = ({
  isOpen,
  onClose
}: ErrorNavigationModalProps) => {
  const [countdown, setCountdown] = useState(10)
  const { updateLocation } = useRestaurant()
  const ooLocations = useOOLocations()

  const handleNavigateBack = useCallback(async () => {
    if (ooLocations?.[0]) {
      updateLocation(ooLocations[0].externalId)
      onClose()
    }
  }, [ooLocations, updateLocation, onClose])

  useEffect(() => {
    let timer: number

    if (isOpen && countdown > 0) {
      timer = window.setTimeout(() => {
        setCountdown((prev) => prev - 1)
      }, 1000)
    } else if (countdown === 0) {
      handleNavigateBack()
    }

    return () => {
      if (timer) {
        window.clearTimeout(timer)
      }
    }
  }, [isOpen, countdown, handleNavigateBack])

  // Reset countdown when modal opens
  useEffect(() => {
    if (isOpen) {
      setCountdown(10)
    }
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} onClose={onClose} testId='error-navigation-modal'>
      <ModalOverlay />
      <ModalContent contentClassName='modalContentV2 errorNavigationModal'>
        <div className='error-content'>
          <div className='error-header'>
            <NoItems />
            <h2>{t('error-navigation-modal.title')}</h2>
          </div>
          <p>{t('error-navigation-modal.message')}</p>
          <div className='countdown'>
            {t('error-navigation-modal.redirecting-in', { seconds: countdown })}
          </div>

          <BrandedButton
            variant={ButtonType.Inverted}
            onClick={handleNavigateBack}
            className='cancelButton'
          >
            {t('error-navigation-modal.go-back-now')}
          </BrandedButton>
        </div>
      </ModalContent>
    </Modal>
  )
}
